import React from 'react';
import { Badge } from 'components';
import './CategoryTab.scss';

export const CategoryTab = ({
  activeTab,
  setActiveTab,
  tabs,
  badgeCounts = {},
}) => {
  return (
    <div className='category-tab'>
      {tabs.map((category) => (
        <button
          key={category.id}
          className={`category-tab-button ${
            activeTab === category.id ? 'active' : ''
          }`}
          onClick={() => setActiveTab(category.id)}
        >
          <span className='category-tab-button-content'>
            <span className='category-tab-button-label'>{category.label}</span>
            <Badge count={badgeCounts[category.id]} />
          </span>
        </button>
      ))}
    </div>
  );
};
